/**
 * @typedef {import('../contracts/menu.js').MenuItem} MenuItem
 */

/**
 * Creates a mock menu adapter that fetches menu items from the API.
 * @param {{ apiClient: import('../contracts/api.js').ApiClient }} deps
 */
export function createMockMenuAdapter({ apiClient }) {
  /**
   * @param {AbortSignal} [signal]
   * @returns {Promise<MenuItem[]>}
   */
  async function fetchMenu(signal) {
    const first = /** @type {{ rows: MenuItem[], total: number, page: number, pageSize: number }} */ (
      await apiClient.get('/menu?page=1&pageSize=500', { signal })
    );
    /** @type {MenuItem[]} */
    const all = first.rows.slice();

    if (first.total > all.length) {
      const totalPages = Math.ceil(first.total / first.pageSize);
      for (let p = 2; p <= totalPages; p++) {
        const next = /** @type {{ rows: MenuItem[] }} */ (
          await apiClient.get(`/menu?page=${p}&pageSize=500`, { signal })
        );
        all.push(...next.rows);
      }
    }

    return all;
  }

  return { fetchMenu };
}
